import React, { useState } from "react";
import Swal from "sweetalert2";
import ReLoginModal from "../components/ReLoginModal";
import "../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { useNavigate } from "react-router-dom";
import api from "../util/axios";

interface RequiRefundDetails {
  quantity: string;
  productId: string;
}

interface RequiRefundProps {
  handleRequiRefund: () => void;
  requisitionNum: any;
  requisitionId: any;
  setRequiRefund: React.Dispatch<React.SetStateAction<boolean>>;
  items: any[]; // Updated from [] to any[]
}

const RequiRefund: React.FC<RequiRefundProps> = ({
  handleRequiRefund,
  requisitionId,
  setRequiRefund,
  items = [], // Default value if items is undefined
}) => {
  const [reLogin, setReLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [requiRefundDetails, setRequiRefundDetails] =
    useState<RequiRefundDetails>({
      quantity: "",
      productId: "",
    });

  const token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const navigate = useNavigate();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setRequiRefundDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleRequiRefundSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    api
      .post(
        `/requisition/${requisitionId}/refund`,
        requiRefundDetails,
        { headers }
      )
      .then((res) => {
        Swal.fire({
          title: "Success!",
          text: res.data.message,
          icon: "success",
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setRequiRefund(false);
        navigate(-1); // Go back to previous page
      })
      .catch((err) => {
        Swal.fire({
          title: "Error!",
          text: err.response.data.message,
          icon: "error",
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        setLoading(false);
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
      });
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Refund</h4>
          <ImCancelCircle
            className="catCancel"
            onClick={() => {
              handleRequiRefund();
              navigate("/dashboard/accept");
            }}
          />
        </div>
        {reLogin ? <ReLoginModal /> : null}
        <div className="line"></div>
        <form onSubmit={handleRequiRefundSubmit} className="invoiceTable">
          <div className="catModalInput branchInput noM">
            <input
              type="text"
              placeholder="Quantity"
              name="quantity"
              value={requiRefundDetails.quantity}
              onChange={handleInputChange}
            />
            <select
              name="productId"
              onChange={handleInputChange}
              value={requiRefundDetails.productId}
            >
              <option value="">Select Product</option>
              {items.map((item: any) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            </select>
            <div className="crBtn sstest">
              <button type="submit" disabled={loading}>
                {loading ? "Processing..." : "Submit Refund"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequiRefund;
